import { render, staticRenderFns } from "./drfSmgSetting.vue?vue&type=template&id=3f569ded&scoped=true"
import script from "./drfSmgSetting.vue?vue&type=script&lang=js"
export * from "./drfSmgSetting.vue?vue&type=script&lang=js"
import style0 from "./drfSmgSetting.vue?vue&type=style&index=0&id=3f569ded&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f569ded",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f569ded')) {
      api.createRecord('3f569ded', component.options)
    } else {
      api.reload('3f569ded', component.options)
    }
    module.hot.accept("./drfSmgSetting.vue?vue&type=template&id=3f569ded&scoped=true", function () {
      api.rerender('3f569ded', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manageCenter/components/drfSmgSetting.vue"
export default component.exports